/**
 * @changelog
 *
 * 2026-03-17 (0.1.0) (jhoward)
 *   - Add new src\helpers\isOfferSoldOut.ts to determine if an offer is sold out.
 */

import type { OpcOffer } from '@/defs/api/OpcOffer';

export default function isOfferSoldOut(offer: OpcOffer): boolean {
  if ('OFR' === offer.CASINO_OFFER_DOMAIN) {
    return false;
  }

  for (let i = 0, l = offer._PRIZES.length; i < l; i++) {
    if (offer._PRIZES[i].CAN_BE_SELECTED === 'YES') {
      return false;
    }
  }

  return true;
}
